export const commonEnvironment = {
  version: '0.0.0',
  authRealm: 'helvetas',
  authClientId: 'helvetas',
  offlineDetection: {
    intervalMs: 5000,
  },
  sentry: {
    dsn: undefined as string | undefined,
  },
  regulations: {
    privateCarKmReimbursementChf: 0.7,
  },
  disableTimeTracking: true,
  expensePartSearchDate: '2026-01-01T00:00:00.000Z',
};
